import { useFilterValue } from '@btime/react-contexts'
import React from 'react'

import { useFilterValueText } from '../../../utils/helpers/filters'
import FilterLink from '../../../components/filter/FilterLink'
import FilterListItem from '../../../components/list/FilterListItem'
import MinicrudsFilterSideModal from './MinicrudsFilterSideModal'

const MinicrudsFilter = ({ label, field, placeLevelField, icon, presentation, ...props }) => {
  const [open, setOpen] = React.useState(false)

  presentation = presentation || 'bar'
  field = field || 'typeIds'
  label = label || 'Tipos'
  const value = useFilterValue(field, [])

  const selectedValue = useFilterValueText(field)
  const Link = presentation === 'bar' ? FilterLink : FilterListItem

  return (
    <>
      <Link
        icon={presentation === 'bar' && 'BsTag'}
        label={label}
        value={selectedValue}
        onClick={() => setOpen(true)}
      />

      <MinicrudsFilterSideModal
        open={open}
        onClose={() => setOpen(false)}
        value={value}
        label={label}
        field={field}
        {...props}
      />
    </>
  )
}

export default MinicrudsFilter
